<div id="makingImpactCarousel" class="carousel slide" data-bs-ride="carousel">
  <div class="carousel-inner">
    @for (impactGroup of impactGroups; track impactGroup; let i = $index) {
      <div class="carousel-item" [ngClass]="{ 'active': i === 0 }">
        <div class="row">
          @for (impact of impactGroup; track impact) {
            <div class="col-12 col-md-4">
              <div class="card h-100 border-0 searchCard">
                <a href="{{ impact.href }}" onclick="return false" target="_blank" class="text-center"
                  aria-label="Hispanic SBDC Link">
                  <img src="{{ impact.img }}" class="card-img-top mx-auto logoImg" alt="{{ impact.alt }}" />
                </a>
                <div class="card-body"></div>
              </div>
            </div>
          }
        </div>
      </div>
    }
  </div>
  <button class="carousel-control-prev" type="button" data-bs-target="#makingImpactCarousel" data-bs-slide="prev">
    <span class="carousel-control-prev-icon" aria-hidden="true"></span>
    <span class="visually-hidden">Previous</span>
  </button>
  <button class="carousel-control-next" type="button" data-bs-target="#makingImpactCarousel" data-bs-slide="next">
    <span class="carousel-control-next-icon" aria-hidden="true"></span>
    <span class="visually-hidden">Next</span>
  </button>
</div>